module.exports = __webpack_public_path__ + "DINNextRoundedLTPro-Bold.woff?cfcb04c0e1c2dffc3ac8ce7f0ac2fcf0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextRoundedLTPro-Bold.woff
// module id = 1425
// module chunks = 0